import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { BusinessType, CartSession, InteractionType, ItemsDisplayType, KeyValues10, KeyValues15, KeyValues3, LocalService, NumericConfig, Status, SummaryType, Wrappers10, Wrappers15 } from '../../../service/local.service';
import { ProductManagementService } from '../../../service/product-management.service';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { BillingManagementService } from 'src/service/billing-management.service';
import { environment } from 'src/environments/environment';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrl: './items.component.scss'
})
export class ItemsComponent {
  @Input() businessId: string | undefined = undefined; @Input() isOnlyActive = true;
  @Input() countryCode: string = ''; @Input() businessType: BusinessType = BusinessType.EndCustomer;
  @Input() itemsDisplayType: ItemsDisplayType = ItemsDisplayType.ProductsForOneBusiness; @Input() tableId: string = '0';

  cartSession: CartSession; searchKey: string = '';

  lstSectionConfigKeys: string[] = ["billing"];

  segregatedItems: KeyValues15[][] = []; classNameRow = 'col-2'; itemsPerRow = 6;
  wrappers: Wrappers15; isSummaryDetailPopupOpen = false; selectedSummaryId = ''; selectedSummaryType = SummaryType.Product;

  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig; maxBodyHeight = 0;
  isRequeCheckInitiated = false;

  elementIds: any; htmlId: string = ''; selectedCategory: string = '0';

  constructor(public localService: LocalService, private router: Router, private cdr: ChangeDetectorRef, private configurationManagementService: ConfigurationManagementService, private productManagementService: ProductManagementService, private billingManagementService: BillingManagementService, ngbCarouselConfig: NgbCarouselConfig) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      item_title: 'item_title_' + this.htmlId,
      item_imgs: 'item_imgs_' + this.htmlId
    };

    ngbCarouselConfig.interval = 5000;
    ngbCarouselConfig.wrap = false;
    ngbCarouselConfig.keyboard = false;
    ngbCarouselConfig.pauseOnHover = false;
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    if (!this.localService.reques) {
      this.onCheckReques(true);
    } else {
      this.onGetCartSession(true);
    }
  }

  onCheckReques(isLoadItems = false) {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.onGetCartSession(isLoadItems);
          }
        });
      } else {
        this.onGetCartSession(isLoadItems);
      }
    } else {
      this.onGetCartSession(isLoadItems);
    }
  }

  onGetCartSession(isLoadItems = false) {
    if (this.itemsDisplayType != ItemsDisplayType.OnlyBusiness && this.businessId && this.localService.selected.user) {
      this.productManagementService.getCartSession(this.businessId, this.countryCode).subscribe(result => {
        this.cartSession = result
        if (isLoadItems) {
          this.onLoad();
        }
      });
    } else {
      if (isLoadItems) {
        this.onLoad();
      }
    }
  }

  onLoad() {
    this.productManagementService.getItemsToDisplay(!this.wrappers ? null : this.wrappers.paging, this.itemsDisplayType, this.isOnlyActive, this.businessType, this.businessId, this.countryCode).subscribe(result => {
      this.wrappers = result;
      if (this.wrappers && this.wrappers.productCategories) {
        if (this.wrappers.productCategories.length > 0) {
          if (this.wrappers.productCategories.findIndex(x => x.key == '0') == -1) {
            this.wrappers.productCategories.unshift({ key: '0', v1: this.localService.languageContent.billing.all_products } as KeyValues3);
          }

          if (this.wrappers.productCategories.findIndex(x => x.key == '1') == -1) {
            this.wrappers.productCategories.unshift({ key: '1', v1: this.localService.languageContent.billing.selected_products } as KeyValues3);
          }
        }
      }
      this.onUpdateQty();
      this.onResize(null, false);
    });
  }

  onSegregateItems() {
    let itemsFilter = this.searchKey ? (JSON.parse(JSON.stringify(this.wrappers.items)) as KeyValues15[]).filter(x => x.v1.toLowerCase().includes(this.searchKey.toLowerCase())) : this.wrappers.items;

    if (this.selectedCategory && this.selectedCategory != '0') {
      if (this.selectedCategory == '1') {
        itemsFilter = itemsFilter.filter(x => x.value && x.value > 0);
      } else {
        itemsFilter = itemsFilter.filter(x => x.v10 && x.v10.includes(this.selectedCategory));
      }
    }
    const totalItems = itemsFilter.length;
    const segregatedRowsStr: string = (totalItems > this.itemsPerRow ? (totalItems / this.itemsPerRow) : this.itemsPerRow).toString();
    const segregatedRows: number = segregatedRowsStr.indexOf('.') > -1 ? (parseInt(segregatedRowsStr.split('.')[0]) + 1) : parseInt(segregatedRowsStr);

    this.segregatedItems = [];
    for (var i = 0; i < segregatedRows; i++) {
      const start = i * this.itemsPerRow;
      const end = start + this.itemsPerRow;
      const items = itemsFilter.slice(start, end);
      this.segregatedItems.push(items);
    }
  }

  onResize(e?: any, isTimeDelayNeed = true) {
    setTimeout(() => {
      switch (this.itemsDisplayType) {
        case ItemsDisplayType.OnlyBusiness: {
          if (window.innerWidth > 1400) {
            this.itemsPerRow = 4;
            this.classNameRow = 'col-md-3';
          } else if (window.innerWidth > 1000) {
            this.itemsPerRow = 3;
            this.classNameRow = 'col-md-4';
          } else if (window.innerWidth > 700) {
            this.itemsPerRow = 2;
            this.classNameRow = 'col-6';
          } else {
            this.itemsPerRow = 1;
            this.classNameRow = 'col-12';
          }
        } break;
        default: {
          if (window.innerWidth > 1400) {
            this.itemsPerRow = 6;
            this.classNameRow = 'col-md-2';
          } else if (window.innerWidth > 1100) {
            this.itemsPerRow = 4;
            this.classNameRow = 'col-md-3';
          } else if (window.innerWidth > 500) {
            this.itemsPerRow = 3;
            this.classNameRow = 'col-md-4';
          } else if (window.innerWidth > 350) {
            this.itemsPerRow = 2;
            this.classNameRow = 'col-md-6';
          } else {
            this.itemsPerRow = 1;
            this.classNameRow = 'col-12';
          }
        } break;
      }
      this.onSegregateItems();
    }, isTimeDelayNeed ? 500 : 0);
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.localService.galleryViewUrl = this.wrappers.items.find(x => x.key == key).values;
      } break;
      case 2: {
        if (this.itemsDisplayType == ItemsDisplayType.OnlyBusiness) {
          this.router.navigate(['/bv/' + this.countryCode, key]);
        }
      } break;
      case 3: {
        this.billingManagementService.createBillingFromCartSession(this.cartSession.Id, this.tableId).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            if (this.tableId && this.tableId.length > 5) {
              this.router.navigate(['/billing-tbl/' + this.countryCode, this.localService.selected.user, InteractionType.User, this.businessId, result.id, this.tableId]);
            } else {
              this.router.navigate(['/billing/' + this.countryCode, this.localService.selected.user, InteractionType.User, this.businessId, result.id]);
            }
          }
        });
      } break;
      case 4: {
        if (this.itemsDisplayType == ItemsDisplayType.OnlyBusiness) {
          this.selectedSummaryType = SummaryType.Business;
        } else {
          this.selectedSummaryType = SummaryType.Product;
        }
        this.selectedSummaryId = key;
        this.isSummaryDetailPopupOpen = true;
      } break;
    }
  }

  onAdjustQuickQty(index, strKey, strQty, rowIndex = 0) {
    if (this.localService.selected.user) {
      let qty: number = strQty && strQty != '' ? parseFloat(strQty) : 0;
      switch (index) {
        case 1: {
          qty = qty - 1;
        } break;
        case 2: {
          if (!qty || qty == 0)
            qty = 1;
          else
            qty = qty + 1;
        } break;
      }
      qty = qty >= 1 ? qty : null;
      this.onSaveCart(strKey, qty);
      this.segregatedItems[rowIndex].find(x => x.key == strKey).value = qty;
    } else {
      this.localService.onLogin();
    }
  }

  onUpdateQty() {
    if (this.cartSession && this.cartSession.BusinessId) {
      this.wrappers.items.filter(x => x.v9 == this.cartSession.BusinessId).forEach(item => {
        const productQty = this.cartSession.ProductIdQuantity.find(x => x.key == item.key);
        item.value = productQty ? parseFloat(productQty.value.toString()) : null;
      });
    }
  }

  onSaveCart(key: string, value: number | null) {
    if (this.localService.selected.user) {
      if (!this.businessId) {
        this.businessId = this.wrappers.items.find(x => x.key == key).v9;
      }
      if (this.businessId) {
        this.productManagementService.SaveCartSession(this.businessId, key, value).subscribe(result => {
          this.cartSession = result;
          this.wrappers.items.find(x=>x.key == key).value = value;
        });
      }
    } else {
      this.onLogin();
    }
  }

  onLogin(qty: number = null) {
    this.localService.redirectUrl = "/bv/" + this.countryCode + "/" + this.businessId;
    this.localService.onLogin();
  }

  onClosesSummaryDetailsPopup(event?: any) {

  }

}
